import { useContext } from "react";
import { Box, Button, Tooltip } from "@mui/material";


import { Logout } from "@mui/icons-material";
import { RoleContext } from "../../../../utils/RoleContext";

import { useNavigate } from "react-router-dom";

const BtnLogout = () => {
  const context = useContext(RoleContext)
  const handleLogout = async () => {
    try {
      context?.vider()
    } catch (e) {
      console.error(e);
    }
  };

  const nav = useNavigate()

  const redirect = () => {
    nav("/profil")
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}

    >
      

      <Tooltip title="Se Deconnecter" placement="top">
        <Button sx={{ ml: 1 }} variant="contained" onClick={handleLogout} endIcon={<Logout />}>
          Se Deconnecter
        </Button>
      </Tooltip>


    </Box>
  );
};

export default BtnLogout;